import React from 'react';
import PropTypes from 'prop-types';

export const ArrowRight = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-right'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12.6 12 8 7.4 9.4 6l6 6-6 6L8 16.6l4.6-4.6Z'
    />
  </svg>
);

ArrowRight.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowRight.defaultProps = {
  width: 24,
  height: 24,
};
